import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTable } from '@angular/material/table';
import * as moment from 'moment';
import { Firmware } from 'src/app/shared/models/firmware';
import { DeviceService } from 'src/app/shared/services/device/device.service';
import { HelperService } from 'src/app/shared/services/helper/helper.service';
import { AddAppVersionUpdateComponent } from '../add-app-version-update/add-app-version-update.component';
import { ActivatedRoute } from '@angular/router';
import { AppVersionUpdateService } from 'src/app/shared/services/app-version-update/app-version-update.service';

@Component({
  selector: 'app-app-version-updates',
  templateUrl: './app-version-updates.component.html',
  styleUrls: ['./app-version-updates.component.scss'],
})
export class AppVersionUpdatesComponent implements OnInit {
  public data = {};
  public isProcessing = false;
  public pageIndex: number = 0;
  public pageSize: number = 15;
  displayedColumns: string[] = [
    'index',
    // 'action',
    'id',
    'platform_type',
    'version',
    'is_force_update',
    'release_notes',
    'created_by',
    'createdAt',
  ];
  dataSource: any = [];
  pageSizeOptions: number[] = [5, 10, 15, 25, 100];
  public searchText: any;
  public toDate: any = '';
  public fromDate: any = '';
  public selectedPlatform: any = [];
  public selectedForceUpdate: any = '';
  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator = Object.create(null);
  @ViewChild(MatTable) table: MatTable<any> = Object.create(null);
  @ViewChild('appVersionUpdateSearch') appVersionUpdateSearch: ElementRef | any;
  // Order
  public orderOn = 'id';
  public orderBy = 'desc';
  public futureDate = new Date();

  // Tooltip
  public tooltip = {
    view_firmware: 'View Firmware',
    update_firmware: 'Update Firmware',
    delete_firmware: 'Delete Firmware',
  };

  // Search mechanism
  public searchedText: string = '';
  public showSearch: boolean = false;
  public searchOptions = ['name'];
  public searchOn = [];
  public length: number = 0;

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    private appVersionUpdateService: AppVersionUpdateService,
    public dialog: MatDialog,
    public datePipe: DatePipe,
    private helperService: HelperService,
    private deviceService: DeviceService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.setDefaultDates();
    this.getAppVersionUpdates();
  }

  setDefaultDates() {
    const params: any = this.route.queryParams;
    if (params.value && params.value.fromDate) {
      this.fromDate = new Date(params.value.fromDate);
    }
    if (params.value && params.value.toDate) {
      this.toDate = new Date(params.value.toDate);
    }
  }

  onDateRangeChange() {
    if (!!this.fromDate && !!this.toDate) {
      this.getAppVersionUpdates();
    }
  }

  sortData(event?: any) {
    const { active, direction } = event;
    this.orderOn = active;
    this.orderBy = direction;
    this.getAppVersionUpdates();
  }

  setDefaultPage(event?: PageEvent) {
    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    } else {
      this.pageIndex = 0;
    }
  }

  async getAppVersionUpdates(event?: PageEvent) {
    try {
      if (event) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
      }
      this.isProcessing = true;
      let mTypeURL = '';

      // SEARCH
      if (this.searchedText) {
        mTypeURL += `&search=${this.searchedText}`;
        this.setDefaultPage(event);
      }
      if (this.searchOn.length) {
        mTypeURL += `&searchOn=${JSON.stringify(this.searchOn)}`;
        this.setDefaultPage(event);
      }

      // Force Update
      if (this.selectedForceUpdate) {
        mTypeURL += `&is_force_update=${this.selectedForceUpdate}`;
        this.setDefaultPage(event);
      }

      // Platform Types
      if (this.selectedPlatform && this.selectedPlatform.length > 0) {
        mTypeURL += `&platform_types=${JSON.stringify(this.selectedPlatform)}`;
        this.setDefaultPage(event);
      }

      // ORDER
      if (this.orderOn && this.orderBy) {
        mTypeURL += `&orderOn=${
          this.orderOn
        }&orderBy=${this.orderBy.toUpperCase()}`;
        this.setDefaultPage(event);
      }

      // FILTERS
      if (this.fromDate && this.toDate) {
        mTypeURL += `&fromDate=${moment(this.fromDate).format(
          'YYYY-MM-DD'
        )}&toDate=${moment(this.toDate).format('YYYY-MM-DD')}`;
        this.setDefaultPage(event);
      }
      mTypeURL += `&page=${this.pageIndex + 1}&perPage=${this.pageSize}`;
      const res = await this.appVersionUpdateService.getAppVersionUpdates(
        mTypeURL
      );
      if (res) {
        this.data = res.data.appUpdates;
        this.dataSource = res.data.appUpdates;
        this.length = res.data.count;
      }
    } catch (err: any) {
      this.helperService.showAlert(
        err.error || 'Something went wrong',
        'error'
      );
    } finally {
      this.isProcessing = false;
    }
  }

  clearSearch() {
    this.searchedText = '';
    this.searchOn = [];
    this.showHideSearch();
    this.getAppVersionUpdates();
  }

  showHideSearch() {
    this.showSearch = !this.showSearch;
    setTimeout(() => {
      if (
        this.appVersionUpdateSearch &&
        this.appVersionUpdateSearch.nativeElement
      ) {
        this.appVersionUpdateSearch.nativeElement.focus();
      }
    });
  }

  isFilterApplied() {
    return !(
      this.selectedPlatform.length > 0 ||
      this.selectedForceUpdate.length > 0 ||
      this.toDate
    );
  }

  clearFilter() {
    // this.selectedDeviceTypes = [];
    this.fromDate = '';
    this.toDate = '';
    this.selectedPlatform = [];
    this.selectedForceUpdate = '';
    this.getAppVersionUpdates();
  }

  openDialog(action: string, obj: any): void {
    obj.action = action;
    const dialogRef = this.dialog.open(AddAppVersionUpdateComponent, {
      maxWidth: '700px',
      maxHeight: '90vh',
      data: obj,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.event) {
        if (result.event === 'Add') {
          if (result.success) {
            this.addRowData(result.data);
          }
        } else if (result.event === 'Delete') {
          if (result.success) {
            this.deleteRowData(result.data);
          }
        }
      }
    });
  }

  addRowData(row_obj: Firmware): void {
    if (this.dataSource.length === this.pageSize) {
      this.dataSource.pop();
    }
    this.dataSource = [row_obj, ...this.dataSource];
    this.length += 1;
    this.table.renderRows();
  }

  updateRowData(row_obj: Firmware): boolean | void {
    const index = this.dataSource.findIndex((d: any) => d.id === row_obj.id);
    if (index != -1) {
      this.dataSource[index] = row_obj;
    }
    this.table.renderRows();
  }

  deleteRowData(row_obj: Firmware) {
    this.getAppVersionUpdates();
  }
}
